export default class XMLHttpRequestAsync {
    static send(xhr, data) {
        return new Promise((resolve, reject) => {
            xhr.onload = (e) => {
                resolve(e);
            };
            xhr.onerror = (e) => {
                reject(e);
            };
            xhr.send(data);
        });
    }
}



// WEBPACK FOOTER //
// ./src/Base/XMLHttpRequestAsync.ts